<template>
  <div>
    <base-header class="pb-6">
      <b-row class="align-items-center py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">Variable Expense</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb/>
          </nav>
        </b-col>
        <!--
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </b-col>
        -->
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col lg="12">
          <div class="card-wrapper">
            <!-- Input groups -->
            <card>
              <!-- Card header -->
              <h3 slot="header" class="mb-0">New Variable Expense</h3>
              <!-- Card body -->
              <form>
                <!-- Input groups with icon -->
                <b-row>
                  <b-col md="4">
                    <base-input label="Variable Expense Title" placeholder="Title" v-model="variable_expense.variable_expense_title"></base-input>
                  </b-col>
                  <b-col md="4">
                    <base-input label="Variable Expense Value" placeholder="Value" v-model="variable_expense.variable_expense_value"></base-input>
                  </b-col>
                </b-row>
                <br>
                <base-button type="primary" @click="createData()">Create / Save</base-button>
                <base-button type="primary" @click="$router.back()">Cancel</base-button>
              </form>
            </card>

          </div>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
  import {LoginURL, clientId, clientSecret, apiDomain, getHeader} from '@/assets/js/config.js'
  import axios from 'axios'
  import clientPaginationMixin from '@/assets/js/clientPaginationMixin'

  export default {
    mixins: [clientPaginationMixin],
    components: {
    },
    data() {
      return {
        variable_expense: {
          variable_expense_title: null,
          variable_expense_value: null,
        },
      }
    },
    created() {
    },
    methods: {
      selectionChange(selectedRows) {
        this.selectedRows = selectedRows
      },
      createData(){
        if(this.variable_expense.variable_expense_title == null && this.variable_expense.variable_expense_value == null){
          _gNotif.redErrorNotify( '<b>Invalid Input : Please fill up the variable expense title and variable expense value. </b>')
        }
        else
        {
          const postData = {
            variable_expense_title : this.variable_expense.variable_expense_title,
            variable_expense_value : this.variable_expense.variable_expense_value,
          }

          axios.post(apiDomain + 'setup/variable_expense', postData ,{ headers: getHeader() })
          .then ( response => {
            if (response.status === 200)
            {
              this.$notify({
                message:
                  '<b>New Variable Expense : ' + response.data.data[0].variable_expense_title + '</b> - Successfully Created.',
                timeout: 10000,
                icon: 'ni ni-bell-55',
                type: 'default',
              });
              this.$router.back()
            }
          })
          .catch ( error => {
               
              _gNotif.errorFunction(error,null, "Add Variable Expense")
              
          });
        }
      },
    },
  }
</script>